module.exports = "/build/images/icons-public.eb76a22f.svg";


//////////////////
// WEBPACK FOOTER
// ./html/images/icons-public.svg
// module id = WIg7
// module chunks = 0